"use strict";

// Devuelve una etiqueta legible a partir de un texto que puede traer marcado.
//
// El nombre de una plantilla es una ETIQUETA -se muestra en un selector, en una
// columna, en un titulo-, asi que tiene que verse como texto y no como codigo.
// Cuando un nombre trae HTML, mostrarlo crudo pinta "<p>Prueba</p>" en la
// pantalla y el administrador no puede elegir nada con confianza. Esto no
// arregla el dato: lo hace legible mientras el dato se corrige.
//
// No usa innerHTML ni monta nada en el DOM a proposito: recibe texto que viene
// de la base y volcarlo en un nodo para "leer" su textContent ejecutaria lo que
// ese texto traiga. Se resuelve con reemplazos sobre la cadena.
const HTML_TAG = /<[^>]*>/g;
const HTML_ENTITY = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
};

const plainText = value => {
  if (value === null || value === undefined) return "";
  let text = String(value).replace(HTML_TAG, " ");
  Object.keys(HTML_ENTITY).forEach(entity => {
    text = text.split(entity).join(HTML_ENTITY[entity]);
  });
  // Los saltos y los espacios repetidos que deja el marcado se colapsan: una
  // etiqueta ocupa una linea.
  return text.replace(/\s+/g, " ").trim();
};

export default plainText;
